module.exports = __webpack_public_path__ + "img/64.7451f46c.png";